<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ $tt(formTitle) }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item :label="$tt('用户id')" prop="userId" >
        <a-input v-model="form.userId" :placeholder="$tt('请输入用户id')" />
      </a-form-model-item>
      <a-form-model-item :label="$tt('温度')" prop="tem" >
        <a-input v-model="form.tem" :placeholder="$tt('请输入温度')" />
      </a-form-model-item>
      <a-form-model-item :label="$tt('调节时间')" prop="time" >
        <a-input v-model="form.time" :placeholder="$tt('请输入调节时间')" />
      </a-form-model-item>
      <a-form-model-item :label="$tt('预留字段1')" prop="strOne" >
        <a-input v-model="form.strOne" :placeholder="$tt('请输入预留字段1')" />
      </a-form-model-item>
      <a-form-model-item :label="$tt('预留字段2')" prop="strTwo" >
        <a-input v-model="form.strTwo" :placeholder="$tt('请输入预留字段2')" />
      </a-form-model-item>
      <a-form-model-item :label="$tt('备注')" prop="remark" >
        <a-input v-model="form.remark" :placeholder="$tt('请输入内容')" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $tt('保存') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $tt('取消') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { translateText } from '@/locales/text'

import { getSetting, addSetting, updateSetting } from '@/api/cio/setting'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        userId: null,

        tem: null,

        time: null,

        strOne: null,

        strTwo: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        userId: [
          { required: true, get message () { return translateText('用户id不能为空') }, trigger: 'blur' }
        ],
        tem: [
          { required: true, get message () { return translateText('温度不能为空') }, trigger: 'blur' }
        ],
        time: [
          { required: true, get message () { return translateText('调节时间不能为空') }, trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        userId: null,
        tem: null,
        time: null,
        strOne: null,
        strTwo: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getSetting({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateSetting(this.form).then(response => {
              this.$message.success(
                translateText('修改成功'),
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addSetting(this.form).then(response => {
              this.$message.success(
                translateText('新增成功'),
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
